module.exports = "/images/vendor/desiigner-svg/svg/logos/48-ore-calabria.svg?e9033f9ea922bf50a84664ad01ccb8de";